/* =============================================
   ABERADERE IMPRESSION — THEME JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile Navigation ----
  const burger = document.querySelector('.site-header__burger');
  const mobileNav = document.querySelector('.mobile-nav');

  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      const isOpen = burger.classList.toggle('is-open');
      mobileNav.classList.toggle('is-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    document.addEventListener('click', function (e) {
      if (!burger.contains(e.target) && !mobileNav.contains(e.target)) {
        burger.classList.remove('is-open');
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });

    document.querySelectorAll('.mobile-nav__link[data-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.dataset.toggle;
        const sub = document.getElementById(targetId);
        if (sub) sub.classList.toggle('is-open');
      });
    });
  }

  // ---- Hero Split Slider ----
  const heroSwiperEl = document.querySelector('.hero-full__swiper');
  if (heroSwiperEl) {
    // Assign Ken Burns variant classes to real slides (before Swiper clones them)
    const kbClasses = ['', 'kb-2', 'kb-3'];
    heroSwiperEl.querySelectorAll('.swiper-slide').forEach(function (slide, i) {
      if (kbClasses[i]) slide.classList.add(kbClasses[i]);
    });

    const heroSwiper = new Swiper(heroSwiperEl, {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      effect: 'fade',
      fadeEffect: { crossFade: true },
      pagination: {
        el: '.hero-full__pagination',
        clickable: true,
      },
      // Defilement au trackpad : geste horizontal a deux doigts.
      // forceToAxis laisse le scroll vertical a la page.
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 12,
        thresholdTime: 500,
      },
      speed: 800,
      on: {
        // Reset animation on each slide so Ken Burns restarts cleanly
        slideChangeTransitionStart: function () {
          this.slides.forEach(function (slide) {
            var img = slide.querySelector('.hero-full__img');
            if (img) {
              img.style.animation = 'none';
              img.offsetHeight; // force reflow
              img.style.animation = '';
            }
          });
        },
      },
    });
  }

  // ---- Testimonials Slider ----
  const testimonialSlider = document.querySelector('.testimonials-slider .swiper');
  if (testimonialSlider) {
    new Swiper(testimonialSlider, {
      loop: true,
      autoplay: { delay: 4500, disableOnInteraction: false },
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
        el: '.testimonials-slider .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
      speed: 600,
    });
  }

  // ---- Parallaxe photos slider ----
  document.querySelectorAll('.parallax-photos-swiper').forEach(function (el) {
    new Swiper(el, {
      loop: true,
      autoplay: { delay: 3000 },
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 800,
      allowTouchMove: false,
    });
  });

  // ---- Scroll Animations ----
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('[data-anim]').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    document.querySelectorAll('[data-anim]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // ---- Stats Counter Animation ----
  const stats = document.querySelectorAll('.stat-item__number[data-count]');
  if (stats.length && 'IntersectionObserver' in window) {
    const statsObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            statsObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    stats.forEach(function (el) { statsObserver.observe(el); });
  }

  function animateCount(el) {
    const target = parseInt(el.dataset.count, 10);
    const suffix = el.dataset.suffix || '';
    const duration = 2000;
    const start = performance.now();
    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target) + suffix;
      if (progress < 1) requestAnimationFrame(update);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(update);
  }

  // ---- Products Filter ----
  const filterBtns = document.querySelectorAll('.products-filter__btn');
  const productCards = document.querySelectorAll('.product-category-card[data-category]');
  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      const filter = btn.dataset.filter;
      productCards.forEach(function (card) {
        if (filter === 'all' || card.dataset.category === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  // ---- Smooth scroll ----
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = document.querySelector('.site-header')?.offsetHeight || 80;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - offset - 16,
          behavior: 'smooth',
        });
      }
    });
  });

  // ---- Header scroll shadow ----
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    window.addEventListener('scroll', function () {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ---- Product category card hover ----
  document.querySelectorAll('.product-category-card').forEach(function (card) {
    card.addEventListener('mouseenter', function () {
      this.querySelector('.product-category-card__overlay')?.style.setProperty('opacity', '1');
    });
    card.addEventListener('mouseleave', function () {
      this.querySelector('.product-category-card__overlay')?.style.setProperty('opacity', '0');
    });
  });

  // ---- Quantity input ----
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-wrapper')?.querySelector('input[type="number"]');
      if (!input) return;
      const step = parseInt(input.step || 1);
      const min = parseInt(input.min || 1);
      const val = parseInt(input.value || 1);
      if (this.dataset.action === 'minus') {
        input.value = Math.max(min, val - step);
      } else {
        input.value = val + step;
      }
      input.dispatchEvent(new Event('change'));
    });
  });

  // ---- Lazy-load images ----
  if ('loading' in HTMLImageElement.prototype) {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.dataset.src) img.src = img.dataset.src;
    });
  }

});
